module.exports = __webpack_public_path__ + "img/instagram.88ba3f4c.png";